var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showConsentRetryError)?_c('consent-retry-failure',{attrs:{"source":_vm.credsSource,"close-action":_vm.redirect}}):(_vm.consentFailure)?_c('consent-failure',{attrs:{"source":_vm.credsSource,"close-action":_vm.redirect}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }